import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
`;

export const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-top: ${({ theme }) => theme.spacings.small};
	gap: ${({ theme }) => theme.spacings.xxsmall};
	padding: ${({ theme }) => `0 ${theme.spacings.small}`};
`;

export const Title = styled(Text)`
	margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
`;
